// Import Alpine (CDN version)
import Alpine from 'alpinejs';

window.Alpine = Alpine;
Alpine.start();

// Your custom scripts here
console.log('Custom scripts running...');